module.exports = __webpack_public_path__ + "static/media/b2.bf23286.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangxingxing/b2.mp3
// module id = 3WjU
// module chunks = 0